import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'components/Icon';
import Image from 'components/Image';

const Legacy = ({
  theme,
  sharedTheme,
  buttonItem,
  buttonOnClick,
  imgSrc,
  children,
  rendered,
  backgroundInline,
  onClose,
}) => {
  if (!rendered) return null;
  const innerContainerStyle = backgroundInline && { ...backgroundInline };
  const image = imgSrc && <Image source={imgSrc} className={theme.image} alt="" />;
  const validButton = buttonItem || buttonOnClick;
  const button = validButton && (
    <button className={theme.button} onClick={buttonOnClick}>
      {buttonItem || ''}
    </button>
  );
  const closeButton = onClose && (
    <div className={theme.close} onClick={onClose} aria-label="close">
      <Icon color="white" icon="close" size="large" />
    </div>
  );
  const hasOnClose = onClose ? theme.hasOnClose : '';
  const containerClass = classNames(sharedTheme.container, theme.container);
  const innerContainerClasses = classNames(
    sharedTheme.innerContainer,
    theme.innerContainer,
    hasOnClose,
  );

  return (
    <div className={containerClass}>
      <div className={innerContainerClasses} style={innerContainerStyle}>
        {closeButton}
        <div className={theme.content}>
          {image}
          {children}
          {button}
        </div>
      </div>
    </div>
  );
};

Legacy.propTypes = {
  theme: PropTypes.shape({}),
  sharedTheme: PropTypes.shape({}),
  imgSrc: PropTypes.string,
  buttonItem: PropTypes.node,
  buttonOnClick: PropTypes.func,
  rendered: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  backgroundInline: PropTypes.shape({}),
  onClose: PropTypes.func,
};

Legacy.defaultProps = {
  theme: {},
  sharedTheme: {},
  imgSrc: '',
  buttonItem: null,
  buttonOnClick: () => {},
  rendered: false,
  children: null,
  backgroundInline: {},
  onClose: null,
};

export default Legacy;
